"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8269],{

/***/ 78269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BrowserMonitoringClient": function() { return /* binding */ BrowserMonitoringClient; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../packages/monitoring/src/core/MonitoringClient.ts
var core_MonitoringClient = __webpack_require__(88175);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
;// CONCATENATED MODULE: ../../packages/monitoring/src/formatters/LogFormatter.ts






var LogFormatter = /*#__PURE__*/ function() {
    "use strict";
    function LogFormatter() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_class_call_check/* default */.Z)(this, LogFormatter);
        this.config = config;
    }
    var _proto = LogFormatter.prototype;
    /**
   * Formats a message to string, handling different input types
   */ _proto.formatMessage = function formatMessage(message) {
        if (typeof message === "string") {
            return message;
        }
        if ((0,_instanceof/* default */.Z)(message, Error)) {
            return message.message;
        }
        if (typeof message === "object" && message !== null) {
            return this.serializeSafe(message);
        }
        return String(message);
    };
    /**
   * Safely serializes objects to JSON without circular references
   */ _proto.serializeSafe = function serializeSafe(obj) {
        var seen = new WeakSet();
        return JSON.stringify(obj, function(key, value) {
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) {
                    return "[Circular Reference]";
                }
                seen.add(value);
            }
            // Handle special cases
            if (typeof value === "function") {
                return "[Function]";
            }
            if (typeof value === "undefined") {
                return undefined // Keep undefined as undefined in JSON
                ;
            }
            if ((0,_instanceof/* default */.Z)(value, Date)) {
                return value.toISOString();
            }
            if ((0,_instanceof/* default */.Z)(value, RegExp)) {
                return value.toString();
            }
            return value;
        });
    };
    /**
   * Formats an Error object into a structured object
   */ _proto.formatError = function formatError(error) {
        return {
            name: error.name,
            message: error.message,
            stack: error.stack,
            cause: error.cause ? this.formatError(error.cause) : undefined
        };
    };
    /**
   * Truncates a message if it exceeds the maximum length
   */ _proto.truncateMessage = function truncateMessage(message, maxLength) {
        if (message.length <= maxLength) {
            return message;
        }
        var truncated = message.substring(0, maxLength - 3);
        return "".concat(truncated, "...");
    };
    /**
   * Formats metadata safely, handling circular references and special types
   */ _proto.formatMetadata = function formatMetadata(metadata) {
        var _this = this;
        return Object.entries(metadata).reduce(function(formatted, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if ((0,_instanceof/* default */.Z)(value, Error)) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formatted), (0,_define_property/* default */.Z)({}, key, _this.formatError(value)));
            }
            if (typeof value === "object" && value !== null) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formatted), (0,_define_property/* default */.Z)({}, key, JSON.parse(_this.serializeSafe(value))));
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formatted), (0,_define_property/* default */.Z)({}, key, value));
        }, {});
    };
    /**
   * Sanitizes log message by removing potentially sensitive information
   */ _proto.sanitizeMessage = function sanitizeMessage(message) {
        var _enableSanitization;
        var shouldSanitize = (_enableSanitization = this.config.enableSanitization) !== null && _enableSanitization !== void 0 ? _enableSanitization : true;
        if (!shouldSanitize) {
            return message;
        }
        // Remove potential passwords, tokens, and keys
        return message.replace(/password\s*[=:]\s*[^\s&]*/gi, "password=***").replace(/token\s*[=:]\s*[^\s&]*/gi, "token=***").replace(/key\s*[=:]\s*[^\s&]*/gi, "key=***").replace(/secret\s*[=:]\s*[^\s&]*/gi, "secret=***").replace(/authorization\s*[=:]\s*[^&]*/gi, "authorization=***");
    };
    LogFormatter.create = function create(config) {
        return new LogFormatter(config);
    };
    return LogFormatter;
}();

// EXTERNAL MODULE: ../../node_modules/zod/v3/types.js + 1 modules
var types = __webpack_require__(53538);
// EXTERNAL MODULE: ../../node_modules/zod/v3/ZodError.js
var ZodError = __webpack_require__(82799);
;// CONCATENATED MODULE: ../../packages/monitoring/src/validators/MetricValidator.ts







var MetricValidator = /*#__PURE__*/ function() {
    "use strict";
    function MetricValidator(logFormatter, config) {
        (0,_class_call_check/* default */.Z)(this, MetricValidator);
        this.logFormatter = logFormatter;
        var ref, ref1, ref2, ref3;
        this.config = {
            maxMetadataKeys: (ref = config === null || config === void 0 ? void 0 : config.maxMetadataKeys) !== null && ref !== void 0 ? ref : 20,
            maxMetadataSize: (ref1 = config === null || config === void 0 ? void 0 : config.maxMetadataSize) !== null && ref1 !== void 0 ? ref1 : 5000,
            maxKeyLength: (ref2 = config === null || config === void 0 ? void 0 : config.maxKeyLength) !== null && ref2 !== void 0 ? ref2 : 50,
            reservedKeys: (ref3 = config === null || config === void 0 ? void 0 : config.reservedKeys) !== null && ref3 !== void 0 ? ref3 : [
                "timestamp",
                "usecase",
                "duration",
                "success"
            ]
        };
    }
    var _proto = MetricValidator.prototype;
    /**
   * Creates metadata schema with instance configuration
   */ _proto.createMetadataSchema = function createMetadataSchema() {
        var _this = this;
        return types/* record */.IM(types/* unknown */._4()).superRefine(function(metadata, ctx) {
            var keys = Object.keys(metadata);
            // Check number of keys
            if (keys.length > _this.config.maxMetadataKeys) {
                ctx.addIssue({
                    code: ZodError/* ZodIssueCode.custom */.NL.custom,
                    message: "metadata cannot have more than ".concat(_this.config.maxMetadataKeys, " keys")
                });
            }
            // Check serialized size
            try {
                var serializedSize = _this.logFormatter.serializeSafe(metadata).length;
                if (serializedSize > _this.config.maxMetadataSize) {
                    ctx.addIssue({
                        code: ZodError/* ZodIssueCode.custom */.NL.custom,
                        message: "metadata size must be less than ".concat(_this.config.maxMetadataSize / 1000, "KB when serialized")
                    });
                }
            } catch (error) {
                ctx.addIssue({
                    code: ZodError/* ZodIssueCode.custom */.NL.custom,
                    message: "metadata contains non-serializable values"
                });
            }
            // Validate individual keys
            keys.forEach(function(key) {
                if (key.length === 0) {
                    ctx.addIssue({
                        code: ZodError/* ZodIssueCode.custom */.NL.custom,
                        message: "metadata keys cannot be empty"
                    });
                    return;
                }
                if (key.length > _this.config.maxKeyLength) {
                    ctx.addIssue({
                        code: ZodError/* ZodIssueCode.custom */.NL.custom,
                        message: 'metadata key "'.concat(key, '" must be less than ').concat(_this.config.maxKeyLength, " characters")
                    });
                    return;
                }
                // Check for reserved keys
                if (_this.config.reservedKeys.includes(key)) {
                    ctx.addIssue({
                        code: ZodError/* ZodIssueCode.custom */.NL.custom,
                        message: 'metadata key "'.concat(key, '" is reserved and cannot be used')
                    });
                    return;
                }
                // Validate value for circular references
                var value = metadata[key];
                if (value !== null && typeof value === "object") {
                    try {
                        JSON.stringify(value);
                    } catch (error) {
                        ctx.addIssue({
                            code: ZodError/* ZodIssueCode.custom */.NL.custom,
                            message: 'metadata value for key "'.concat(key, '" contains circular references')
                        });
                    }
                }
            });
        });
    };
    /**
   * Creates metric entry schema with instance configuration
   */ _proto.createMetricEntrySchema = function createMetricEntrySchema() {
        return types/* object */.Ry({
            id: types/* string */.Z_({
                required_error: "id is required and must be a string",
                invalid_type_error: "id is required and must be a string"
            }),
            usecase: types/* string */.Z_({
                required_error: "usecase is required and must be a string",
                invalid_type_error: "usecase is required and must be a string"
            }).min(1, "usecase cannot be empty").max(100, "usecase must be less than 100 characters").regex(/^[a-zA-Z][a-zA-Z0-9_]*$/, "usecase must start with a letter and contain only letters, numbers, and underscores"),
            duration: types/* number */.Rx({
                required_error: "duration is required and must be a number",
                invalid_type_error: "duration is required and must be a number"
            }).min(0, "duration must be a positive number").max(1000000, "duration must be less than 1,000,000ms (16.6 minutes)"),
            success: types/* boolean */.O7({
                required_error: "success is required and must be a boolean",
                invalid_type_error: "success is required and must be a boolean"
            }),
            timestamp: types/* number */.Rx({
                invalid_type_error: "timestamp must be a number"
            }).min(0, "timestamp must be positive").optional(),
            metadata: this.createMetadataSchema().optional()
        });
    };
    /**
   * Validates a MetricEntry and returns validation result
   */ _proto.validate = function validate(metric) {
        var schema = this.createMetricEntrySchema();
        var result = schema.safeParse(metric);
        if (result.success) {
            return {
                isValid: true,
                errors: [],
                sanitizedMetric: this.sanitizeMetric(result.data)
            };
        }
        var errors = result.error.errors.map(function(err) {
            return err.message;
        });
        return {
            isValid: false,
            errors: errors,
            sanitizedMetric: undefined
        };
    };
    /**
   * Validates metadata object structure and content
   */ _proto.validateMetadata = function validateMetadata(metadata) {
        var schema = this.createMetadataSchema();
        var result = schema.safeParse(metadata);
        if (result.success) {
            return {
                errors: []
            };
        }
        return {
            errors: result.error.errors.map(function(err) {
                return err.message;
            })
        };
    };
    /**
   * Sanitizes metadata by removing sensitive information and invalid values
   */ _proto.sanitizeMetadata = function sanitizeMetadata(metadata) {
        var _this = this;
        return Object.entries(metadata).reduce(function(sanitized, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            // Skip reserved keys
            if (_this.config.reservedKeys.includes(key)) {
                return sanitized;
            }
            // Sanitize sensitive keys
            var lowerKey = key.toLowerCase();
            if (lowerKey.includes("password") || lowerKey.includes("token") || lowerKey.includes("secret") || lowerKey.includes("key")) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sanitized), (0,_define_property/* default */.Z)({}, key, "***"));
            }
            // Handle different value types
            var sanitizedValue;
            if (value === null || value === undefined) {
                sanitizedValue = value;
            } else if (typeof value === "string") {
                // Truncate long strings
                sanitizedValue = value.length > 200 ? "".concat(value.substring(0, 197), "...") : value;
            } else if (typeof value === "number" || typeof value === "boolean") {
                sanitizedValue = value;
            } else if (typeof value === "object") {
                try {
                    // Ensure object is serializable
                    JSON.stringify(value);
                    sanitizedValue = value;
                } catch (e) {
                    sanitizedValue = "[Non-serializable Object]";
                }
            } else {
                sanitizedValue = String(value);
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sanitized), (0,_define_property/* default */.Z)({}, key, sanitizedValue));
        }, {});
    };
    /**
   * Sanitizes a complete metric entry
   */ _proto.sanitizeMetric = function sanitizeMetric(metric) {
        var sanitized = {
            id: metric.id,
            usecase: metric.usecase,
            duration: Math.round(metric.duration * 100) / 100,
            success: metric.success
        };
        // Add timestamp if provided or generate one
        if (metric.timestamp) {
            sanitized.timestamp = metric.timestamp;
        } else {
            sanitized.timestamp = Date.now();
        }
        // Sanitize metadata
        if (metric.metadata) {
            sanitized.metadata = this.sanitizeMetadata(metric.metadata);
        }
        return sanitized;
    };
    /**
   * Quick validation for basic required fields (optimized for performance)
   */ _proto.isValidBasic = function isValidBasic(metric) {
        var BasicMetricSchema = types/* object */.Ry({
            usecase: types/* string */.Z_().min(1),
            duration: types/* number */.Rx().min(0),
            success: types/* boolean */.O7()
        });
        return BasicMetricSchema.safeParse(metric).success;
    };
    MetricValidator.create = function create(logFormatter, config) {
        return new MetricValidator(logFormatter !== null && logFormatter !== void 0 ? logFormatter : LogFormatter.create(), config);
    };
    return MetricValidator;
}();

;// CONCATENATED MODULE: ../../packages/monitoring/src/formatters/MetricFormatter.ts




var MetricFormatter = /*#__PURE__*/ function() {
    "use strict";
    function MetricFormatter(logFormatter, config) {
        (0,_class_call_check/* default */.Z)(this, MetricFormatter);
        this.logFormatter = logFormatter;
        var ref, ref1, ref2;
        this.config = {
            metricPrefix: (ref = config === null || config === void 0 ? void 0 : config.metricPrefix) !== null && ref !== void 0 ? ref : "",
            maxTagLength: (ref1 = config === null || config === void 0 ? void 0 : config.maxTagLength) !== null && ref1 !== void 0 ? ref1 : 50,
            maxTagCount: (ref2 = config === null || config === void 0 ? void 0 : config.maxTagCount) !== null && ref2 !== void 0 ? ref2 : 10
        };
    }
    var _proto = MetricFormatter.prototype;
    /**
   * Formats a metric for DataDog using optimized multi-metric approach
   * Returns 2 metrics: duration (gauge) and executions (count)
   */ _proto.formatForDataDogMultiMetric = function formatForDataDogMultiMetric(metric) {
        var timestamp = metric.timestamp || Date.now();
        var baseTimestamp = Math.floor(timestamp / 1000);
        var baseTags = [
            "use_case:".concat(this.convertPascalToSnakeCase(metric.usecase)), 
        ].concat((0,_to_consumable_array/* default */.Z)(this.extractTags(metric.metadata)));
        return [
            // Métrica de duración
            {
                metric: "".concat(this.config.metricPrefix, ".usecase.duration"),
                points: [
                    [
                        baseTimestamp,
                        metric.duration
                    ]
                ],
                tags: (0,_to_consumable_array/* default */.Z)(baseTags).concat([
                    "success:".concat(metric.success)
                ]),
                type: "gauge"
            },
            // Métrica de contador de ejecuciones
            {
                metric: "".concat(this.config.metricPrefix, ".usecase.executions"),
                points: [
                    [
                        baseTimestamp,
                        1
                    ]
                ],
                tags: (0,_to_consumable_array/* default */.Z)(baseTags).concat([
                    "success:".concat(metric.success)
                ]),
                type: "count"
            }, 
        ];
    };
    /**
   * Extracts tags from metadata for DataDog
   */ _proto.extractTags = function extractTags(metadata) {
        var _this = this;
        if (!metadata) return [];
        var tags = Object.entries(metadata).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
            return value !== null && value !== undefined;
        }).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            // Convert value to string and sanitize
            var stringValue = String(value).replace(/[^a-zA-Z0-9_.-]/g, "_").substring(0, _this.config.maxTagLength) // Limit tag value length
            ;
            var sanitizedKey = key.replace(/[^a-zA-Z0-9_]/g, "_").toLowerCase().substring(0, 30) // Limit tag key length
            ;
            return "".concat(sanitizedKey, ":").concat(stringValue);
        }).slice(0, this.config.maxTagCount) // Limit number of tags
        ;
        return tags;
    };
    /**
   * Converts PascalCase to snake_case
   * Example: GetCurrentMarketSharedUseCase -> get_current_market_shared_use_case
   */ _proto.convertPascalToSnakeCase = function convertPascalToSnakeCase(text) {
        return text.replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2").replace(/([a-z\d])([A-Z])/g, "$1_$2").toLowerCase();
    };
    MetricFormatter.create = function create(logFormatter, config) {
        return new MetricFormatter(logFormatter !== null && logFormatter !== void 0 ? logFormatter : LogFormatter.create(), config);
    };
    return MetricFormatter;
}();

;// CONCATENATED MODULE: ../../packages/monitoring/src/formatters/PayloadProcessor.ts





var PayloadProcessor = /*#__PURE__*/ function() {
    "use strict";
    function PayloadProcessor(metricFormatter, logFormatter, compressionOptions) {
        (0,_class_call_check/* default */.Z)(this, PayloadProcessor);
        this.metricFormatter = metricFormatter;
        this.logFormatter = logFormatter;
        var ref, ref1, ref2;
        this.compressionOptions = {
            removeWhitespace: (ref = compressionOptions === null || compressionOptions === void 0 ? void 0 : compressionOptions.removeWhitespace) !== null && ref !== void 0 ? ref : true,
            abbreviateKeys: (ref1 = compressionOptions === null || compressionOptions === void 0 ? void 0 : compressionOptions.abbreviateKeys) !== null && ref1 !== void 0 ? ref1 : true,
            maxStringLength: (ref2 = compressionOptions === null || compressionOptions === void 0 ? void 0 : compressionOptions.maxStringLength) !== null && ref2 !== void 0 ? ref2 : 200
        };
    }
    var _proto = PayloadProcessor.prototype;
    /**
   * Compresses a unified payload to reduce size
   */ _proto.compress = function compress(payload) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var opts = (0,_object_spread/* default */.Z)({}, this.compressionOptions, options);
        var compressed = payload;
        // Apply compression techniques
        if (opts.abbreviateKeys) {
            compressed = this.abbreviateKeys(compressed);
        }
        if (opts.maxStringLength > 0) {
            compressed = this.truncateStrings(compressed, opts.maxStringLength);
        }
        // Serialize with optional whitespace removal
        var jsonString = opts.removeWhitespace ? JSON.stringify(compressed) : JSON.stringify(compressed, null, 2);
        return jsonString;
    };
    /**
   * Chunks a payload into smaller pieces if it exceeds maxSize
   */ _proto.chunk = function chunk(payload, maxSize) {
        if (payload.length <= maxSize) {
            return [
                payload
            ];
        }
        var chunks = [];
        try {
            var parsed = JSON.parse(payload);
            // Try to split by logs and metrics first
            if (parsed.logs && parsed.metrics) {
                var logsPayload = JSON.stringify({
                    logs: parsed.logs
                });
                var metricsPayload = JSON.stringify({
                    metrics: parsed.metrics
                });
                if (logsPayload.length <= maxSize && metricsPayload.length <= maxSize) {
                    return [
                        logsPayload,
                        metricsPayload
                    ];
                }
            }
            // If that doesn't work, chunk logs and metrics separately
            if (parsed.logs) {
                var _chunks;
                (_chunks = chunks).push.apply(_chunks, (0,_to_consumable_array/* default */.Z)(this.chunkLogs(parsed.logs, maxSize)));
            }
            if (parsed.metrics) {
                var _chunks1;
                (_chunks1 = chunks).push.apply(_chunks1, (0,_to_consumable_array/* default */.Z)(this.chunkMetrics(parsed.metrics, maxSize)));
            }
            return chunks.length > 0 ? chunks : [
                payload.substring(0, maxSize)
            ];
        } catch (e) {
            // If parsing fails, do simple string chunking
            return this.chunkString(payload, maxSize);
        }
    };
    /**
   * Optimizes a payload by removing redundancy and compressing data
   */ _proto.optimize = function optimize(payload) {
        var optimized = {};
        if (payload.logs && payload.logs.length > 0) {
            optimized.logs = this.optimizeLogs(payload.logs);
        }
        if (payload.metrics && payload.metrics.length > 0) {
            optimized.metrics = this.optimizeMetrics(payload.metrics);
        }
        return optimized;
    };
    /**
   * Processes a payload completely: optimize, compress, and chunk if needed
   */ _proto.process = function process(payload, maxSize, compressionOptions) {
        // Step 1: Optimize the payload
        var optimized = this.optimize(payload);
        // Step 2: Compress the payload
        var compressed = this.compress(optimized, compressionOptions);
        // Step 3: Check if chunking is needed
        if (compressed.length <= maxSize) {
            return {
                payload: compressed,
                size: compressed.length,
                compressed: true
            };
        }
        // Step 4: Chunk if necessary
        var chunks = this.chunk(compressed, maxSize);
        return {
            payload: chunks[0],
            size: compressed.length,
            compressed: true,
            chunks: chunks.slice(1)
        };
    };
    /**
   * Abbreviates common keys to reduce payload size
   */ _proto.abbreviateKeys = function abbreviateKeys(payload) {
        var keyMap = {
            timestamp: "ts",
            message: "msg",
            metadata: "meta",
            sessionId: "sid",
            userAgent: "ua",
            usecase: "uc",
            duration: "dur",
            success: "ok"
        };
        return JSON.parse(JSON.stringify(payload, function(key, value) {
            return value;
        }).replace(/"(timestamp|message|metadata|sessionId|userAgent|usecase|duration|success)":/g, function(match, key) {
            return '"'.concat(keyMap[key] || key, '":');
        }));
    };
    /**
   * Truncates long strings in the payload
   */ _proto.truncateStrings = function truncateStrings(payload, maxLength) {
        var _this = this;
        return JSON.parse(JSON.stringify(payload, function(key, value) {
            if (typeof value === "string" && value.length > maxLength) {
                return _this.logFormatter.truncateMessage(value, maxLength);
            }
            return value;
        }));
    };
    /**
   * Chunks logs into smaller arrays
   */ _proto.chunkLogs = function chunkLogs(logs, maxSize) {
        var chunks = [];
        var currentChunk = [];
        var currentSize = 0;
        logs.forEach(function(log) {
            var logSize = JSON.stringify({
                logs: [
                    log
                ]
            }).length;
            if (currentSize + logSize > maxSize && currentChunk.length > 0) {
                chunks.push(JSON.stringify({
                    logs: currentChunk
                }));
                currentChunk = [
                    log
                ];
                currentSize = logSize;
            } else {
                currentChunk.push(log);
                currentSize += logSize;
            }
        });
        if (currentChunk.length > 0) {
            chunks.push(JSON.stringify({
                logs: currentChunk
            }));
        }
        return chunks;
    };
    /**
   * Chunks metrics into smaller arrays
   */ _proto.chunkMetrics = function chunkMetrics(metrics, maxSize) {
        var chunks = [];
        var currentChunk = [];
        var currentSize = 0;
        metrics.forEach(function(metric) {
            var metricSize = JSON.stringify({
                metrics: [
                    metric
                ]
            }).length;
            if (currentSize + metricSize > maxSize && currentChunk.length > 0) {
                chunks.push(JSON.stringify({
                    metrics: currentChunk
                }));
                currentChunk = [
                    metric
                ];
                currentSize = metricSize;
            } else {
                currentChunk.push(metric);
                currentSize += metricSize;
            }
        });
        if (currentChunk.length > 0) {
            chunks.push(JSON.stringify({
                metrics: currentChunk
            }));
        }
        return chunks;
    };
    /**
   * Simple string chunking as fallback
   */ _proto.chunkString = function chunkString(str, maxSize) {
        var chunks = [];
        for(var i = 0; i < str.length; i += maxSize){
            chunks.push(str.substring(i, i + maxSize));
        }
        return chunks;
    };
    /**
   * Optimizes logs by removing duplicates and redundant data
   */ _proto.optimizeLogs = function optimizeLogs(logs) {
        var _this = this;
        // Remove exact duplicates
        var seen = new Set();
        var uniqueLogs = [];
        logs.forEach(function(log) {
            // Create a hash of the log (excluding timestamp for dedup)
            var logHash = _this.logFormatter.serializeSafe({
                level: log.level,
                message: log.message,
                metadata: log.metadata
            });
            if (!seen.has(logHash)) {
                seen.add(logHash);
                uniqueLogs.push(log);
            }
        });
        // Sort by timestamp for better compression
        return uniqueLogs.sort(function(a, b) {
            return (a.timestamp || 0) - (b.timestamp || 0);
        });
    };
    /**
   * Optimizes metrics by removing duplicates and aggregating similar ones
   */ _proto.optimizeMetrics = function optimizeMetrics(metrics) {
        var _this = this;
        // Group by usecase for potential aggregation
        var grouped = new Map();
        metrics.forEach(function(metric) {
            var key = metric.usecase;
            if (!grouped.has(key)) {
                grouped.set(key, []);
            }
            var group = grouped.get(key);
            if (group) {
                group.push(metric);
            }
        });
        var optimized = [];
        // For now, just remove exact duplicates and sort
        // In the future, we could implement aggregation here
        Array.from(grouped.values()).forEach(function(usecaseMetrics) {
            var seen = new Set();
            usecaseMetrics.forEach(function(metric) {
                var metricHash = _this.logFormatter.serializeSafe({
                    id: metric.id,
                    usecase: metric.usecase,
                    duration: metric.duration,
                    success: metric.success,
                    metadata: metric.metadata
                });
                if (!seen.has(metricHash)) {
                    seen.add(metricHash);
                    optimized.push(metric);
                }
            });
        });
        return optimized.sort(function(a, b) {
            return (a.timestamp || 0) - (b.timestamp || 0);
        });
    };
    /**
   * Expands abbreviated keys back to their original form for a single LogEntry
   */ _proto.expandLogKeys = function expandLogKeys(log) {
        var reverseKeyMap = {
            ts: "timestamp",
            msg: "message",
            meta: "metadata",
            sid: "sessionId",
            ua: "userAgent",
            uc: "usecase",
            dur: "duration",
            ok: "success"
        };
        return JSON.parse(JSON.stringify(log).replace(/"(ts|msg|meta|sid|ua|uc|dur|ok)":/g, function(match, key) {
            return '"'.concat(reverseKeyMap[key] || key, '":');
        }));
    };
    PayloadProcessor.create = function create(metricFormatter, logFormatter, compressionOptions) {
        return new PayloadProcessor(metricFormatter !== null && metricFormatter !== void 0 ? metricFormatter : MetricFormatter.create(), logFormatter !== null && logFormatter !== void 0 ? logFormatter : LogFormatter.create(), compressionOptions);
    };
    return PayloadProcessor;
}();

;// CONCATENATED MODULE: ../../packages/monitoring/src/utils/Sampler.ts

var Sampler = /*#__PURE__*/ function() {
    "use strict";
    function Sampler(samplingRate) {
        (0,_class_call_check/* default */.Z)(this, Sampler);
        this.samplingRate = samplingRate;
        if (samplingRate < 0 || samplingRate > 1) {
            throw new Error("Sampling rate must be between 0 and 1");
        }
    }
    var _proto = Sampler.prototype;
    _proto.shouldSample = function shouldSample() {
        return Math.random() < this.samplingRate;
    };
    Sampler.create = function create() {
        var samplingRate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.1;
        return new Sampler(samplingRate);
    };
    return Sampler;
}();

// EXTERNAL MODULE: ../../node_modules/debug/src/browser.js
var browser = __webpack_require__(25130);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ../../packages/monitoring/src/utils/CircuitBreaker.ts


var log = browser_default()("s4l:monitoring:circuitBreaker");
var CircuitBreaker = /*#__PURE__*/ function() {
    "use strict";
    function CircuitBreaker() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _maxEventsPerMinute = ref.maxEventsPerMinute, maxEventsPerMinute = _maxEventsPerMinute === void 0 ? 100 : _maxEventsPerMinute, _windowMs = ref.windowMs, windowMs = _windowMs === void 0 ? 60000 : _windowMs, _cooldownMs = ref.cooldownMs, cooldownMs = _cooldownMs === void 0 ? 120000 : _cooldownMs;
        (0,_class_call_check/* default */.Z)(this, CircuitBreaker);
        this.eventCount = 0;
        this.windowStart = Date.now();
        this.circuitOpen = false;
        this.circuitOpenedAt = 0;
        this.maxEventsPerMinute = maxEventsPerMinute;
        this.windowMs = windowMs;
        this.cooldownMs = cooldownMs;
    }
    var _proto = CircuitBreaker.prototype;
    _proto.shouldAcceptEvent = function shouldAcceptEvent() {
        var now = Date.now();
        // If circuit is open, check if we can close it
        if (this.circuitOpen) {
            var timeSinceOpened = now - this.circuitOpenedAt;
            if (timeSinceOpened < this.cooldownMs) {
                // Still in cooldown period
                return false;
            }
            // Close the circuit
            log("[CircuitBreaker] Closing circuit after cooldown");
            this.circuitOpen = false;
            this.eventCount = 0;
            this.windowStart = now;
        }
        // Reset window if it has expired
        if (now - this.windowStart >= this.windowMs) {
            this.eventCount = 0;
            this.windowStart = now;
        }
        // Increment event counter
        this.eventCount += 1;
        // Check if we exceed the limit
        if (this.eventCount > this.maxEventsPerMinute) {
            if (!this.circuitOpen) {
                this.circuitOpen = true;
                this.circuitOpenedAt = now;
                log("[CircuitBreaker] Circuit OPENED - Too many events (".concat(this.eventCount, "/").concat(this.maxEventsPerMinute, "). ") + "Cooling down for ".concat(this.cooldownMs / 1000, "s."));
            }
            return false;
        }
        return true;
    };
    _proto.isOpen = function isOpen() {
        return this.circuitOpen;
    };
    _proto.getStatus = function getStatus() {
        var now = Date.now();
        var remainingCooldownMs = this.circuitOpen ? Math.max(0, this.cooldownMs - (now - this.circuitOpenedAt)) : 0;
        return {
            isOpen: this.circuitOpen,
            eventCount: this.eventCount,
            remainingCooldownMs: remainingCooldownMs
        };
    };
    CircuitBreaker.create = function create() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return new CircuitBreaker(config);
    };
    return CircuitBreaker;
}();

;// CONCATENATED MODULE: ../../packages/monitoring/src/clients/BrowserMonitoringClient.ts















var BrowserMonitoringClient_log = browser_default()("s4l:monitoring:browserClient");
var BrowserMonitoringClient = /*#__PURE__*/ function(MonitoringClient) {
    "use strict";
    (0,_inherits/* default */.Z)(BrowserMonitoringClient, MonitoringClient);
    var _super = (0,_create_super/* default */.Z)(BrowserMonitoringClient);
    function BrowserMonitoringClient() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_class_call_check/* default */.Z)(this, BrowserMonitoringClient);
        var _this;
        _this = _super.call(this);
        _this.logBuffer = [];
        _this.metricBuffer = [];
        _this.flushTimer = null;
        _this.endpoint = config.endpoint || "/api/logs";
        // this.maxBatchSize = config.maxBatchSize || 50
        _this.flushInterval = config.flushInterval || 10000;
        _this.maxPayloadSize = config.maxPayloadSize || 60000;
        _this.sessionId = _this.generateSessionId();
        var _logFormatter;
        // Initialize dependencies
        _this.logFormatter = (_logFormatter = config.logFormatter) !== null && _logFormatter !== void 0 ? _logFormatter : LogFormatter.create();
        var _metricValidator;
        _this.metricValidator = (_metricValidator = config.metricValidator) !== null && _metricValidator !== void 0 ? _metricValidator : MetricValidator.create();
        var _payloadProcessor;
        _this.payloadProcessor = (_payloadProcessor = config.payloadProcessor) !== null && _payloadProcessor !== void 0 ? _payloadProcessor : PayloadProcessor.create();
        var _sampler;
        _this.sampler = (_sampler = config.sampler) !== null && _sampler !== void 0 ? _sampler : Sampler.create();
        var _metricSampler, ref;
        _this.metricSampler = (ref = (_metricSampler = config.metricSampler) !== null && _metricSampler !== void 0 ? _metricSampler : _this.sampler) !== null && ref !== void 0 ? ref : Sampler.create();
        var _circuitBreaker;
        _this.circuitBreaker = (_circuitBreaker = config.circuitBreaker) !== null && _circuitBreaker !== void 0 ? _circuitBreaker : CircuitBreaker.create();
        _this.initializeUnloadStrategy();
        _this.startPeriodicFlush();
        return _this;
    }
    var _proto = BrowserMonitoringClient.prototype;
    _proto.info = function info(param) {
        var message = param.message, metadata = param.metadata;
        if (!this.circuitBreaker.shouldAcceptEvent()) {
            return;
        }
        this.log(core_MonitoringClient/* LogLevel.INFO */.i.INFO, message, metadata);
    };
    _proto.warn = function warn(param) {
        var message = param.message, metadata = param.metadata;
        if (!this.circuitBreaker.shouldAcceptEvent()) {
            return;
        }
        this.log(core_MonitoringClient/* LogLevel.WARN */.i.WARN, message, metadata);
    };
    _proto.error = function error(param) {
        var message = param.message, metadata = param.metadata;
        if (!this.circuitBreaker.shouldAcceptEvent()) {
            return;
        }
        this.log(core_MonitoringClient/* LogLevel.ERROR */.i.ERROR, message, metadata);
    };
    _proto.debug = function debug(param) {
        var message = param.message, metadata = param.metadata;
        if (!this.circuitBreaker.shouldAcceptEvent()) {
            return;
        }
        this.log(core_MonitoringClient/* LogLevel.DEBUG */.i.DEBUG, message, metadata);
    };
    _proto.sendMetric = function sendMetric(metric) {
        var ref;
        if (!this.circuitBreaker.shouldAcceptEvent()) {
            return;
        }
        if (!this.metricSampler.shouldSample()) {
            return;
        }
        if (!this.metricValidator.isValidBasic(metric)) {
            BrowserMonitoringClient_log("[METRIC_VALIDATION_ERROR] Invalid metric ignored:", metric);
            return;
        }
        var _metadata, ref1;
        var sanitizedMetric = this.metricValidator.sanitizeMetric((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, metric), {
            metadata: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (_metadata = metric.metadata) !== null && _metadata !== void 0 ? _metadata : {}), {
                origin: (ref1 = (ref = metric.metadata) === null || ref === void 0 ? void 0 : ref.origin) !== null && ref1 !== void 0 ? ref1 : "browser"
            })
        }));
        this.metricBuffer.push(sanitizedMetric);
    };
    _proto.log = function log(level, message, metadata) {
        // Format and sanitize the message
        var formattedMessage = this.logFormatter.formatMessage(message);
        var sanitizedMessage = this.logFormatter.sanitizeMessage(formattedMessage);
        // Format metadata if provided
        var formattedMetadata = metadata ? this.logFormatter.formatMetadata(metadata) : undefined;
        var logEntry = {
            timestamp: Date.now(),
            level: level,
            message: sanitizedMessage,
            metadata: formattedMetadata,
            sessionId: this.sessionId,
            url: window.location.href,
            userAgent: navigator.userAgent,
            origin: "browser"
        };
        this.logBuffer.push(logEntry);
    // this.maxBatchSizeReached() && this.flush() // eslint-disable-line
    };
    // private maxBatchSizeReached(): boolean {
    //   return this.logBuffer.length + this.metricBuffer.length >= this.maxBatchSize
    // }
    _proto.flush = function flush() {
        if (this.circuitBreaker.isOpen()) {
            // Clear buffers to prevent memory leak
            this.logBuffer = [];
            this.metricBuffer = [];
            return Promise.resolve(false);
        }
        var payload = {
            logs: this.logBuffer.length > 0 ? (0,_to_consumable_array/* default */.Z)(this.logBuffer) : undefined,
            metrics: this.metricBuffer.length > 0 ? (0,_to_consumable_array/* default */.Z)(this.metricBuffer) : undefined
        };
        // Clear buffers
        this.logBuffer = [];
        this.metricBuffer = [];
        return this.sendPayload(payload);
    };
    _proto.sendPayload = function sendPayload(payload) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var processed, mainPromise, chunkPromises;
            return (0,tslib_es6.__generator)(this, function(_state) {
                processed = _this.payloadProcessor.process(payload, _this.maxPayloadSize, {
                    removeWhitespace: true,
                    abbreviateKeys: false,
                    maxStringLength: 200
                });
                mainPromise = _this.sendBeacon(processed.payload);
                // If there are additional chunks, send them too
                if (processed.chunks && processed.chunks.length > 0) {
                    chunkPromises = processed.chunks.map(function(chunk) {
                        return _this.sendBeacon(chunk);
                    });
                    // Return true if at least the main payload succeeds (chunks are best-effort)
                    return [
                        2,
                        mainPromise.then(function(mainSuccess) {
                            if (mainSuccess) {
                                // Send chunks in background without waiting
                                Promise.allSettled(chunkPromises).then(function(results) {
                                    var failedChunks = results.filter(function(r) {
                                        return r.status === "rejected";
                                    }).length;
                                    if (failedChunks > 0) {
                                        BrowserMonitoringClient_log("Failed to send ".concat(failedChunks, " payload chunks"));
                                    }
                                });
                                return true;
                            }
                            return false;
                        })
                    ];
                }
                return [
                    2,
                    mainPromise
                ];
            });
        })();
    };
    _proto.sendBeacon = function sendBeacon(payload) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var blob;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!navigator.sendBeacon) {
                    return [
                        2,
                        false
                    ];
                }
                try {
                    blob = new Blob([
                        payload
                    ], {
                        type: "text/plain"
                    });
                    return [
                        2,
                        navigator.sendBeacon(_this.endpoint, blob)
                    ];
                } catch (e) {
                    return [
                        2,
                        false
                    ];
                }
                return [
                    2
                ];
            });
        })();
    };
    _proto.generateSessionId = function generateSessionId() {
        return Date.now().toString(36) + Math.random().toString(36).substring(2);
    };
    _proto.initializeUnloadStrategy = function initializeUnloadStrategy() {
        var _this = this;
        var sentUnloadBeacon = false;
        var sendUnloadBeacon = function() {
            if (sentUnloadBeacon) return;
            sentUnloadBeacon = true;
            if (!_this.circuitBreaker.isOpen() && _this.sampler.shouldSample() && (_this.logBuffer.length > 0 || _this.metricBuffer.length > 0)) {
                _this.flush();
            }
        };
        // Use pagehide + visibilitychange strategy (doesn't break BFCache)
        if (true) {
            if ("onpagehide" in window) {
                window.addEventListener("pagehide", sendUnloadBeacon, {
                    capture: true
                });
            } else {
                // Fallback for older browsers
                var win = window;
                win.addEventListener("unload", sendUnloadBeacon, {
                    capture: true
                });
                win.addEventListener("beforeunload", sendUnloadBeacon, {
                    capture: true
                });
            }
        }
        if (typeof document !== "undefined") {
            document.addEventListener("visibilitychange", function() {
                if (document.visibilityState === "hidden") {
                    sendUnloadBeacon();
                }
            }, {
                capture: true
            });
        }
    };
    _proto.startPeriodicFlush = function startPeriodicFlush() {
        var _this = this;
        var self = this // eslint-disable-line
        ;
        self.flushTimer = window.setInterval(function() {
            if (!self.circuitBreaker.isOpen() && _this.sampler.shouldSample() && (self.logBuffer.length > 0 || self.metricBuffer.length > 0)) {
                _this.flush().catch(function(error) {
                    BrowserMonitoringClient_log("Error in periodic flush:", error);
                });
            }
        }, self.flushInterval);
    };
    BrowserMonitoringClient.create = function create() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return new BrowserMonitoringClient(config);
    };
    return BrowserMonitoringClient;
}(core_MonitoringClient/* MonitoringClient */.m);


/***/ })

}]);